module.exports = __webpack_public_path__ + "static/media/logo-line-white.ee806225.svg";